<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">活期宝</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>活期宝列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
        <!-- <add-in @refresh="getProjectList"></add-in> -->
        <el-switch :value="interestInfo" @change="chengeInerest"></el-switch>
      </div>
      {{ financialCoinTypeList }}
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';
import AddIn from './components/addIn'

export default {
  name: 'kpiProject',
  data() {
    return {
      updated: '',
      switchInfo:this.interestInfo
    };
  },
  components: {
    List,
    Create,
    AddIn
  },
  computed: {
    ...mapState('cornucopia', ['pagination','financialCoinTypeList','interestInfo'])
  },
  methods: {
    ...mapActions('cornucopia', [
      'getList',
      'getCoinTypeList',
      'freshData',
      'getIdamount','getFinancialCoinTypeList','getInterest','setInterest'
    ]),
    getProjectList(data = {}) {
      this.getList({
        ...data
      });
    },
    update() {
      this.freshData({ target: this.updated }).then(() => {
        this.updated = '';
      });
    },
    chengeInerest(e){
      this.$confirm('确定更改？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.setInterest({isOpen:e}).then(res => {
           if(res.code==0){
            this.getInterest();
            this.$message({
              message: '设置成功！',
              type: 'success'
            });
           }
            
          });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getProjectList();
    this.getCoinTypeList();
    this.getFinancialCoinTypeList();
    this.getInterest();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
